<template>
  <btn :txt="'업로드'"
       :color="'purple'"
       :size="'small'"
       :style="isBtnShow ? '' : 'display: none'"
       @click="upload_click"/>
  <input type="file"
         ref="elFile"
         style="display: none;"
         @change="file_change"/>
</template>

<script setup>
import {defineProps, defineEmits, ref, defineExpose} from 'vue';
import {getStore, getUtils} from "@/utils/import";

const {$file, $valid, $alert, $cmmn} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  se: {
    type: String,
    default: 'tmp',
  },
  maxSize: {
    type: Number,
    default: 10,
  },
  accepts: {
    type: String,
    default: 'gif,png,jpg,jpeg,bmp,doc,docx,xls,xlsx,ppt,pptx,hwp,pdf,zip',
  },
  isResizeImg: { /* 업로드시 이미지 리사이즈 처리 여부 */
    type: Boolean,
    default: false,
  },
  imgMaxSize: { /* 조절가능 사이즈: 720, 1080 */
    type: Number,
    default: 720,
    validator(value) {
      return value == 720 || value == 1080;
    }
  },
  isBtnShow: {
    type: Boolean,
    default: true,
  },
});

const emits = defineEmits(['change']);

const elFile = ref(null);
const upload_click = () => {
  elFile.value.click();
}

const file_change = async () => {
  try {
    $loading.on();

    const {files} = elFile.value;

    // 1. 파일 개수 확인
    if (files.length == 0) return false;

    const file = files[0];
    const {name, size} = file;
    const extsn = $file.getExtsnByFileNm(name);

    // 2. 확장자 확인
    const isValidExtsn = $valid.fileExtsn(extsn, props.accepts);
    if (!isValidExtsn) {
      $alert('확장자를 다시 확인해주세요.');
      return false;
    }

    // 3. 파일 사이즈
    const maxFileSize = props.maxSize * 1024 * 1024;
    if (size > maxFileSize) {
      $alert('업로드 가능한 최대 파일 크기는 ' + props.maxSize + 'MB입니다.');
      return false;
    }

    const se = props.se;
    const options = {
      imgResize: {
        is: false,
        maxSize: 720,
      }
    }
    if (props.isResizeImg) {
      options.imgResize.is = true;
      options.imgResize.maxSize = props.imgMaxSize;
    }
    const fileInfo = await $file.ncp[se].upld(file, options);

    emits('change', fileInfo);
    elFile.value.value = '';

  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

defineExpose({
  upload_click,
})
</script>

<style scoped>

</style>
